import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';
import { endOfMonth, endOfYear, format, isSameMonth, isSameYear, startOfMonth, startOfYear } from 'date-fns-new';
import { useMutableRef } from '@carnica/utils/hooks';
import { DEFAULT_START_YEAR, DEFAULT_YEARS_COUNT, isInInterval } from "../../utils/date";
export var useDatePeriodList = function useDatePeriodList(_ref) {
  var currentVisibleDate = _ref.currentVisibleDate,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'years' : _ref$type,
    _ref$disableDates = _ref.disableDates,
    disableDates = _ref$disableDates === void 0 ? [] : _ref$disableDates,
    onChange = _ref.onChange,
    locale = _ref.locale;
  var onChangeRef = useMutableRef(onChange);
  var periodList = useMemo(function () {
    var startYear = DEFAULT_START_YEAR;
    var month = currentVisibleDate.getMonth();
    var date = currentVisibleDate.getDate();
    if (type === 'years') {
      return Array.from({
        length: DEFAULT_YEARS_COUNT
      }).map(function (_, i) {
        var targetYear = startYear + i;
        var target = new Date(targetYear, month, date, 0, 0, 0, 0);
        return [startOfYear(target), endOfYear(target)];
      });
    }
    return Array.from({
      length: 12
    }).map(function (_, i) {
      var target = new Date(currentVisibleDate.getFullYear(), i, 1, 0, 0, 0, 0);
      return [startOfMonth(target), endOfMonth(target)];
    });
  }, [type, currentVisibleDate]);
  return useMemo(function () {
    var currentDate = new Date();
    return periodList.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        start = _ref3[0],
        end = _ref3[1];
      var disabled = !isInInterval(start, minDate, maxDate) && !isInInterval(end, minDate, maxDate);
      var includesInDisabledRange = !!disableDates.find(function (el) {
        return Array.isArray(el) ? isInInterval(start, el[0], el[1]) && isInInterval(end, el[0], el[1]) : isInInterval(el, start, end);
      });
      return {
        label: format(start, type === 'month' ? 'LLLL' : 'yyyy', {
          locale: locale
        }),
        date: start,
        disabled: disabled || includesInDisabledRange,
        onClick: function onClick(e) {
          var _onChangeRef$current;
          return (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 ? void 0 : _onChangeRef$current.call(onChangeRef, start, e);
        },
        isCurrentDate: (type === 'years' ? isSameYear : isSameMonth)(start, currentDate)
      };
    });
  }, [currentVisibleDate, minDate, maxDate, periodList]);
};